import { makeStyles } from '@material-ui/core/styles';
import { CreativeTemplatesEntities } from '../../../../constants';

export default (activeTabKey: CreativeTemplatesEntities) =>
  makeStyles((theme) => ({
    List: {
      padding: 0,
      margin: 5,
      borderRadius: 8,
      ...(activeTabKey === CreativeTemplatesEntities.CTAs
        ? { display: 'flex', flexWrap: 'wrap', gap: '8px', alignContent: 'flex-start' }
        : {})
    },
    ItemRoot: {
      color: theme.palette.text.secondary,
      marginBottom: 16,
      padding: '8px 16px',
      borderRadius: 4,
      alignItems: 'flex-start',
      ...(activeTabKey === CreativeTemplatesEntities.CTAs ? { flex: '0 32%', height: 'fit-content' } : {}),
      border: `1px solid ${theme.palette.divider}`,
      '& .MuiListItemIcon-root': {
        minWidth: 20
      }
    },
    ListItemText: {
      paddingTop: '7px'
    },
    EmptyMsg: {
      color: theme.palette.text.secondary,
      textAlign: 'center',
      letterSpacing: 2
    },
    Score: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '7px',
      paddingLeft: 10
    }
  }));
